import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { MenuItem } from "primeng/api";

@Component({
  selector: "uni-reference-manager",
  standalone: false,
  templateUrl: "./reference-manager.component.html",
})
export class ReferenceManagerComponent {
  isSidebarCollapsed = false;

  constructor(private router: Router) {}

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  goProductSearch() {
    this.router.navigate(["/product-search"]);
  }

  items: MenuItem[] = [
    {
      label: '<span class="text-l font-bold">Products</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Manufacturers",
          icon: "pi pi-fw pi-building",
          routerLink: ["/references/manage/manufacturers"],
        },
        {
          label: "Product Types",
          icon: "pi pi-fw pi-box",
          routerLink: ["/references/manage/product-types"],
        },
        {
          label: "Features",
          icon: "pi pi-fw pi-list",
          routerLink: ["/references/manage/features"],
        },
        {
          label: "Feature Types",
          icon: "pi pi-fw pi-sliders-h",
          routerLink: ["/references/manage/feature-types"],
        },
        {
          label: "Product Type Tags",
          icon: "pi pi-fw pi-tags",
          routerLink: ["/references/manage/product-type-tags"],
        },
        {
          label: "Manufacturer Product Configs",
          icon: "pi pi-fw pi-cog",
          routerLink: ["/references/manage/manufacturer-product-type-configs"],
        },
        {
          label: "Phaseout Drain",
          icon: "pi pi-fw pi-hourglass",
          routerLink: ["/references/manage/phaseout-drain"],
        },
      ],
    },
    {
      label: '<span class="text-l font-bold">Processing</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Process Stations",
          icon: "pi pi-fw pi-sitemap",
          routerLink: ["/references/manage/process-stations"],
        },
        {
          label: "Add-Ons",
          icon: "pi pi-fw pi-plus-circle",
          routerLink: ["/references/manage/addons"],
        },
      ],
    },
    {
      label: '<span class="text-l font-bold">Shipping</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Box Sizes",
          icon: "pi pi-fw pi-box",
          routerLink: ["/references/manage/box-sizes"],
        },
      ],
    },
    {
      label: '<span class="text-l font-bold">Documentation</span>',
      escape: false,
      expanded: false,
      items: [
        {
          label: "Understanding Product Integrity",
          icon: "pi pi-fw pi-book",
          routerLink: ["/references/manage/documentation/product-integrity"],
        },
        {
          label: "Understanding Manufacturer APIs and Feeds",
          icon: "pi pi-fw pi-book",
          routerLink: ["/references/manage/documentation/manufacturer-feeds"],
        },
        {
          label: "Using Reorder Values",
          icon: "pi pi-fw pi-book",
          routerLink: ["/references/manage/documentation/reorder-feature-choices"],
        },
      ],
    },
  ];
}
